import { cn } from '@/lib/utils'
import './styles.css'

const CLASS_BY_FACE: Record<string, string> = {
  '2': 'status-badge--2xx',
  '3': 'status-badge--3xx',
  '4': 'status-badge--4xx',
  '5': 'status-badge--5xx',
}

/** Badge do status HTTP colorido por faixa (2xx verde … 5xx vermelho). Número sempre visível. */
export function StatusCodeBadge({ status }: { status: number }) {
  const cls = CLASS_BY_FACE[String(status)[0]] ?? 'status-badge--unknown'
  return (
    <span className={cn('status-badge', cls)} title={`HTTP ${status}`}>
      {status}
    </span>
  )
}
